import React from "react";
import DocuSignProcessFailedNotification from "components/notifications/DocuSignProcessFailedNotification";

export const customRenderEvent = (data, state, events) => {
  if (data.customData?.type === "DocuSignProcessFailed") {
    return <DocuSignProcessFailedNotification events={events} />;
  }
};
